import { Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import TableOrder from './TableOrder';

const OrderStatus = ({ dataSource }) => {

    const [data, setData] = useState([])

    useEffect(() => {
        if (dataSource && dataSource.length > 0) {
            setData(dataSource);
        }
    }, [dataSource]);

    const dataProcess = data.filter((item) => item.OrderStatus === "Under Process");
    const dataCompleted = data.filter((item) => item.OrderStatus === "Completed");

    const processTotal = dataProcess.length;
    const completedTotal = dataCompleted.length;

    const items = [
        {
            key: '1',
            label: `Under Process (${processTotal})`,
            children: <TableOrder dataSource={dataProcess} />,
        },
        {
            key: '2',
            label: `Completed (${completedTotal})`,
            children: <TableOrder dataSource={dataCompleted} />,
        },
    ];

    return (
        <div className="w-full bg-white p-4 rounded-md">
            <div className="flex justify-between items-center">
                <p className="text-2xl font-medium">ORDER STATUS</p>
                <p>Total All Items: {data.length}</p>
            </div>
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    )
}

export default OrderStatus